import React, { useState } from 'react';
// import { InboxOutlined } from '@ant-design/icons';
// import type { UploadProps } from 'antd';
import { message, Upload, Spin } from 'antd';
import { getFileHost, getFileUploadToken } from '../../apis';

const { Dragger } = Upload;

const BaseDragAndDropUpload = (props) => {
  const {
    width = '100%',
    height = 0,
    name = 'file',
    multiple = false, //true,
    // action = 'https://localhost:3000/file',
    action = (file) => {
      /*
        FILE: {
          uid,
          lastModified,
          lastModifiedDate,
          name,
          size,
          type : "video/mp4" , "audio/wav"
          webkitRelativePath,
         }
        */
    
      return getFileHost() || 'https://localhost:3000/file'; // 기본값
    },
    onChange = (info) => {
      const { status } = info.file;

      /*
      // log
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      */
      if (status == 'uploading') {
        if (loading == false) {
          setLoading(true);
        }
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
        setUploadFile(info.file);
        setLoading(false);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
        console.error('[file-error]', info);
        setLoading(false);
      }
    },
    onDrop = (e) => {
      // setLoading(true);
      console.log('Dropped files', e.dataTransfer.files);
    },

    contentComponent = (
      <>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading
          company data or other band files
        </p>
      </>
    ),
    //------------------------------------------------------------------------------
    setUploadFile,
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);

  const realHeight = height > 0 ? { height: height - 35 } : {};
  return (
    <Dragger
      name={name}
      multiple={multiple}
      //---------------------------------------------
      action={getFileHost()}
      headers={{
        Authorization: `Bearer ${getFileUploadToken()}`,
      }}
      method="post"
      //Content-Disposition: form-data; name="Filedata"; filename="undefined"
      name="filedata" /// <=== 파일 데이터 저장할 이름
      //---------------------------------------------
      onChange={onChange}
      onDrop={onDrop}
      showUploadList={false}
    >
      <div
        style={{
          display: 'flex',
          width,
          ...realHeight,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {loading ? (
          <Spin
            // tip="Loading"
            size={'large'}
            style={{
              display: 'flex',
              position: 'absolute',
            }}
          />
        ) : (
          <>
            {/* ------------------------------------------------------------- */}
            {/* <p className="ant-upload-drag-icon"> */}
            <img
              width={34.5}
              height={35}
              src={require('../../assets/images/ico_upload.png')}
            />
            <div style={{ marginTop: 10 }} />
            {/* </p> */}
            {/* ------------------------------------------------------------- */}
            {contentComponent()}
          </>
        )}
      </div>
    </Dragger>
  );
};

export default BaseDragAndDropUpload;
